import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["id", "innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "loading-screen"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcModal = _resolveComponent("NcModal")

  return (_openBlock(), _createBlock(_component_NcModal, {
    size: "small",
    container: $props.nestedContainer,
    "label-id": $setup.dialogHeaderId,
    onClose: _cache[7] || (_cache[7] = $event => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!$props.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("p", {
                id: $setup.dialogHeaderId,
                class: "title",
                innerHTML: $options.modalTitle
              }, null, 8, _hoisted_2),
              _createElementVNode("form", {
                onSubmit: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.handleSubmitPermissions && $options.handleSubmitPermissions(...args)), ["prevent"]))
              }, [
                _createVNode(_component_NcCheckboxRadioSwitch, {
                  modelValue: $setup.callStart,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.callStart) = $event)),
                  class: "checkbox"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Start a call')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_NcCheckboxRadioSwitch, {
                  modelValue: $setup.lobbyIgnore,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.lobbyIgnore) = $event)),
                  class: "checkbox"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Skip the lobby')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_NcCheckboxRadioSwitch, {
                  modelValue: $setup.chatMessagesAndReactions,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.chatMessagesAndReactions) = $event)),
                  class: "checkbox"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Can post messages and reactions')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_NcCheckboxRadioSwitch, {
                  modelValue: $setup.publishAudio,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.publishAudio) = $event)),
                  class: "checkbox"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Enable the microphone')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_NcCheckboxRadioSwitch, {
                  modelValue: $setup.publishVideo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.publishVideo) = $event)),
                  class: "checkbox"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Enable the camera')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_NcCheckboxRadioSwitch, {
                  modelValue: $setup.publishScreen,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.publishScreen) = $event)),
                  class: "checkbox"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Share the screen')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_NcButton, {
                  type: "submit",
                  class: "button-update-permission",
                  variant: "primary",
                  disabled: $options.submitButtonDisabled
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Update permissions')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 32)
            ], 64))
          : _createCommentVNode("", true),
        ($props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "icon-loading" }, null, -1)),
              _createElementVNode("p", null, _toDisplayString($options.t('spreed', 'Updating permissions')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["container", "label-id"]))
}